import { useQuery } from "@tanstack/react-query";
import { getUOMList } from "services/data.internal.service";

export const useUOMOptionsQuery = ({ onSuccess }) => {
  return useQuery({
    queryKey: ["uom-options"],
    queryFn: () => getUOMList(),
    onSuccess,
  });
}